<template>
  <transition name="toast">
    <div v-if="visible" class="toast-container" :class="type">
      <div class="toast-content">
        <div class="toast-message">{{ message }}</div>
        <button class="toast-close" @click="hideToast">&times;</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ToastNotification',
  data() {
    return {
      visible: false,
      message: '',
      type: 'info', // info, warning, error, success
      timeout: null
    }
  },
  created() {
    // Register global event bus
    if (this.$root) {
      this.$root.$on('show-toast', this.showToast);
    }
    
    // Register global function for navigation warnings
    window.showNavigationWarning = () => {
      this.showToast({
        message: "SECURITY ALERT: Browser navigation is disabled. Direct use of browser back/forward is blocked for your security.",
        type: 'warning',
        duration: 8000
      });
      
      // Also log to console for developers
      console.warn('Navigation attempt blocked for security reasons');
    };
  },
  beforeDestroy() {
    // Clean up event handlers
    if (this.$root) {
      this.$root.$off('show-toast', this.showToast);
    }
    
    // Clean up global function
    window.showNavigationWarning = null;
    
    // Clear any remaining timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
  methods: {
    showToast({ message, type = 'info', duration = 3000 }) {
      // Clear any existing timeout
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      
      // Update toast data
      this.message = message;
      this.type = type;
      this.visible = true;
      
      // Set auto-hide timeout
      if (duration > 0) {
        this.timeout = setTimeout(() => {
          this.hideToast();
        }, duration);
      }
    },
    hideToast() {
      this.visible = false;
      
      // Clear timeout if it exists
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  max-width: 90%;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  padding: 0;
  overflow: hidden;
  font-weight: 500;
}

.toast-content {
  display: flex;
  align-items: center;
  padding: 15px 20px;
}

.toast-message {
  flex: 1;
  margin-right: 12px;
  font-size: 14px;
  line-height: 1.5;
}

.toast-close {
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
}

.toast-close:hover {
  color: #333;
}

/* Toast types */
.info {
  border-left: 4px solid #2196F3;
}

.warning {
  border-left: 8px solid #FF9800;
  background-color: #FFF8E1;
  font-weight: bold;
}

.error {
  border-left: 8px solid #F44336;
  background-color: #FFEBEE;
  font-weight: bold;
}

.success {
  border-left: 4px solid #4CAF50;
}

/* Toast animations */
.toast-enter-active, .toast-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.toast-enter, .toast-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

/* Add overlay for warnings and errors */
.warning::before, .error::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 100%);
  pointer-events: none;
}
</style> 